export function getVejledningTitle(type: string) {
    switch (type) {
        case 'laerer':
            return 'Lærervejledning';
        case 'video':
            return 'Videovejledning';
        case 'vaerktoejsark':
            return 'Værktøjsark';
        default:
            return 'UKENDT!';
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Vejledning/VejledningTitle.ts